unit SMX.Currency.Format;

interface

const
  SYS_MONEY_FORMAT = '#,##0.00';
  GBP_CURRENCY_SYMBOL = #$00A3;

function FormatGBP(const AValue: Double; const AFormat: string = SYS_MONEY_FORMAT): string; overload;
function FormatGBP(const AValue: string): string; overload;
function FormatGBPDisplay(const AValue: Double; const AEmptyWhenZero: Boolean = True): string;
function TryParseGBP(const AValue: string; out AAmount: Double): Boolean;

implementation

uses
  System.SysUtils;

function NormaliseGBPText(const AValue: string): string;
begin
  Result := Trim(AValue);
  Result := StringReplace(Result, GBP_CURRENCY_SYMBOL, '', [rfReplaceAll]);
  Result := StringReplace(Result, ',', '', [rfReplaceAll]);
  Result := Trim(Result);
end;

function TryParseGBP(const AValue: string; out AAmount: Double): Boolean;
var
  lNormalised: string;
begin
  AAmount := 0;
  lNormalised := NormaliseGBPText(AValue);
  Result := (lNormalised <> '') and TryStrToFloat(lNormalised, AAmount);
end;

function FormatGBP(const AValue: Double; const AFormat: string): string;
begin
  Result := GBP_CURRENCY_SYMBOL + FormatFloat(AFormat, AValue);
end;

function FormatGBP(const AValue: string): string;
var
  lAmount: Double;
begin
  if AValue = '' then
    Exit('');

  if TryParseGBP(AValue, lAmount) then
    Exit(FormatGBP(lAmount));

  if AValue.StartsWith(GBP_CURRENCY_SYMBOL) then
    Exit(AValue);

  Result := GBP_CURRENCY_SYMBOL + AValue;
end;

function FormatGBPDisplay(const AValue: Double; const AEmptyWhenZero: Boolean): string;
begin
  if AEmptyWhenZero and (AValue = 0) then
    Result := ''
  else
    Result := FormatGBP(AValue);
end;

end.
